module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/b494a3e0b00941252c2e1cdde6b17e42.png";